import { createSlice } from '@reduxjs/toolkit';
import passengerService from '../services/passengerService';
import { Passenger } from './models/passenger.model';

interface PassengerState {
  passengers: { [id: string]: Passenger };
  loadingPassenger: boolean;
  loadedPassenger: boolean;
}

export const initialState: PassengerState = {
  passengers: {},
  loadingPassenger: false,
  loadedPassenger: false,
};

export const accountSlice = createSlice({
  name: 'passenger',
  initialState,
  reducers: {
    clearPassengers: (state: PassengerState, action: { type: string }) => {
      state.passengers = {};
    },
    addPassenger: (
      state: PassengerState,
      action: { type: string; payload: Passenger },
    ) => {
      const passenger = action.payload;
      state.passengers[passenger.passengerUUID] = passenger;
    },
    setLoadingPassenger: (
      state: PassengerState,
      action: { type: string; payload: boolean },
    ) => {
      state.loadingPassenger = action.payload;
    },
    setLoadedPassenger: (
      state: PassengerState,
      action: { type: string; payload: boolean },
    ) => {
      state.loadedPassenger = action.payload;
    },
  },
});

// ========================================
// BEGIN REDUX ACTIONS EXPORT
// ========================================

export const { clearPassengers } = accountSlice.actions;
export const { addPassenger } = accountSlice.actions;
export const { setLoadingPassenger } = accountSlice.actions;
export const { setLoadedPassenger } = accountSlice.actions;

// ========================================
// END REDUX ACTIONS EXPORT
// ========================================

export const getPassengerAsync =
  (passengerUUID: string) => (dispatch: Function) => {
    dispatch(setLoadingPassenger(true));
    dispatch(setLoadedPassenger(false));
    passengerService.getPassenger(passengerUUID).subscribe({
      next: (passenger) => {
        dispatch(addPassenger(passenger));
        dispatch(setLoadingPassenger(false));
        dispatch(setLoadedPassenger(true));
      },
      error: (err) => {
        dispatch(setLoadingPassenger(false));
        dispatch(setLoadedPassenger(false));
      },
    });
  };

export const selectpassengers = (state: { passenger: PassengerState }) =>
  state.passenger.passengers;
export const selectLoadingPassenger = (state: { accounting: PassengerState }) =>
  state.accounting.loadingPassenger;
export const selectLoadedPassenger = (state: { accounting: PassengerState }) =>
  state.accounting.loadedPassenger;

export default accountSlice.reducer;
